export enum TicketSourceSubtype {
    none = 0,
    post = 1,
    postedByTeam = 2,
    directMessage = 3,
    mention = 4,
    external = 5,
    internal = 6,
    forward = 7,
}
